import { userRoles, UserRoleTypes } from '../constants/userRoles';
import { loggedInUserDataStore } from '../stores/loggedInUserDataStore';
import { solutionsStore } from '../stores/solutionsStore';
import {
  getHumanizeUserRole,
  FormatConfig,
} from '../utils/userInfoUtils/getHumanizeUserRole/getHumanizeUserRole';

// should be under observer
export const useUserRoleLabel = () => {
  const { loggedInUser } = loggedInUserDataStore;
  const { activeSolution } = solutionsStore;

  const getByRole = (userRole: UserRoleTypes, formatConfig?: FormatConfig) =>
    getHumanizeUserRole(userRole, { solution: activeSolution }, formatConfig);

  const getForCurrentUser = (formatConfig?: FormatConfig) =>
    loggedInUser ? getByRole(loggedInUser.role, formatConfig) : 'Not logged in';

  const getForAgent = (formatConfig?: FormatConfig) =>
    getByRole(userRoles.AGENT, formatConfig);

  const getForSuperAdmin = (formatConfig?: FormatConfig) =>
    getByRole(userRoles.SUPERUSER, formatConfig);

  const getForAdmin = (formatConfig?: FormatConfig) =>
    getByRole(userRoles.ADMIN, formatConfig);

  const getForFoodAdmin = (formatConfig?: FormatConfig) =>
    getByRole(userRoles.FOOD_ADMIN, formatConfig);

  const getForCustomer = (formatConfig?: FormatConfig) =>
    getByRole(userRoles.CUSTOMER, formatConfig);

  return {
    getByRole,
    getForCurrentUser,
    getForAgent,
    getForSuperAdmin,
    getForAdmin,
    getForFoodAdmin,
    getForCustomer,
  };
};
